<script setup lang="ts">
import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { PageSection } from "@/apps/page/page.interfaces";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import {
    TAB_NEW_PROJECT,
    useBindSectionWithProject,
} from "@/apps/page/project/sections/useBindWithProject";
import BindSectionWithToolProjectForm from "@/apps/page/project/sections/BindSectionWithToolProjectForm.vue";
import { useEditorActions } from "@/views/tools/page/utils/useEditorActions";
import { ref } from "vue";
import { AddIcon } from "@easy/ui/icons";

const { connectToolSectionWithProject, bindToolSectionWithProject } = useEditorActions();
const props = defineProps<{
    sectionId?: PageSection["id"];
    tool: InPageUsedTools;
}>();
const {
    selectedTab,
    chosenProjectId,
    shouldHaveExistingOption,
    toolProjects,
    project,
    projectNameError,
    bindWithProject,
    resetForm,
    onFieldBlur,
} = useBindSectionWithProject(props, {
    page: ref({ uuid: "" }),
    routeAfterBind: false,
    connectToolSectionWithProject,
    bindToolSectionWithProject,
});
</script>

<template>
    <div class="flex flex-col items-center sm:w-full md:w-2/3">
        <div class="py-2">
            {{
                shouldHaveExistingOption
                    ? $t("page.bind_section_panel.description")
                    : $t("page.bind_section_panel.description_creation")
            }}
        </div>
        <BindSectionWithToolProjectForm
            class="w-full"
            :isAutofocused="false"
            :sectionId="sectionId"
            :tool="tool"
            :toolProjects="toolProjects"
            :pageNameBlur="onFieldBlur"
            :projectNameError="projectNameError"
            @tabSwitched="resetForm"
            @actionSubmit="bindWithProject"
            v-model:selectedTab="selectedTab"
            v-model:shouldHaveExistingOption="shouldHaveExistingOption"
            v-model:chosenProjectId="chosenProjectId"
            v-model:projectName="project.projectName"
        />
        <div class="my-4 w-full">
            <ButtonPrimaryMd class="w-full" @click="bindWithProject">
                <AddIcon />&nbsp;
                {{
                    selectedTab === TAB_NEW_PROJECT
                        ? $t("page.bind_section_modal.project_new")
                        : $t("page.bind_section_modal.fill_with_project", { tool })
                }}
            </ButtonPrimaryMd>
        </div>
    </div>
</template>

<style scoped></style>
